module.exports = __webpack_public_path__ + "static/img/006_tv0.3522035.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/module/006_tv0.png
// module id = XVKD
// module chunks = 0